import React, { useState } from 'react';
import { DatePicker, Button } from 'antd';
import styled from 'styled-components';
import { PlusCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useMessage } from "../../../uteis/mensagens/useMessage";


const Wrapper = styled.div`
  margin-top: 2rem;
`;

const Titulo = styled.h4`
  font-size: 1.1rem;
  margin-bottom: 1rem;
  color: #222;
`;

const InputArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.2rem;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const BotaoAdd = styled(Button)`
  display: flex;
  align-items: center;
`;

const Lista = styled.ul`
  list-style: none;
  padding-left: 0;
  margin-top: 1rem;
`;

const Item = styled.li`
  background: #f6faff;
  padding: 0.6rem 1rem;
  border-radius: 6px;
  margin-bottom: 0.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333;
`;

const DeleteIcon = styled(DeleteOutlined)`
  cursor: pointer;
  color: #c00;
  margin-left: 1rem;

  &:hover {
    color: #a00;
  }
`;

interface Periodo {
  inicio: string;
  fim: string;
}

interface Props {
  onChange: (periodos: Periodo[]) => void;
}

const SelecaoPeriodos = ({ onChange }: Props) => {
  const [inicio, setInicio] = useState<dayjs.Dayjs | null>(null);
  const [fim, setFim] = useState<dayjs.Dayjs | null>(null);
  const [periodos, setPeriodos] = useState<Periodo[]>([]);
    const { showError, showWarning, contextHolder } = useMessage();

  const adicionarPeriodo = () => {
    if (!inicio || !fim) return;

    const hoje = dayjs().startOf("day");

    if (fim.isBefore(hoje)) {
       showWarning("O período incluúdo já passou. Por favor, selecione datas futuras.");
      return;
    }
        if (fim.isSame(inicio, 'day') || fim.isBefore(inicio, 'day')) {
       showWarning("A data final deve ser posterior à data de início.");
      return;
    }

  

    const novo: Periodo = {
      inicio: inicio.format('YYYY-MM-DD'),
      fim: fim.format('YYYY-MM-DD')
    };

    // evitar duplicata
    const existe = periodos.some(
      (p) => p.inicio === novo.inicio && p.fim === novo.fim
    );

    if (!existe) {
      const atualizados = [...periodos, novo];
      setPeriodos(atualizados);
      onChange(atualizados);
      setInicio(null);
      setFim(null);
    }
  };



  const remover = (idx: number) => {
    const atualizados = [...periodos];
    atualizados.splice(idx, 1);
    setPeriodos(atualizados);
    onChange(atualizados);
  };

  return (
    <Wrapper>
      <Titulo>📅 Quando gostaria de viajar (pode ser mais de um período)?</Titulo>

      <InputArea>
        <Row>
          <DatePicker
            placeholder="Data de início"
            format="DD/MM/YYYY"
            value={inicio}
            onChange={(date) => {
              setInicio(date);
              setFim(null);} }
            style={{ width: '100%' }}
            getPopupContainer={() => document.body}
            disabledDate={(current) => {
              const hoje = dayjs().startOf("day");
              return current && current.isBefore(hoje, "day"); // 🔥 BLOQUEIA PASSADO
            }}
          />

          <DatePicker
            placeholder="Data de fim"
            format="DD/MM/YYYY"
            value={fim}
            onChange={(date) => setFim(date)}
            style={{ width: '100%' }}
            getPopupContainer={() => document.body}
            defaultPickerValue={inicio || undefined} // 🔧 aqui está a mágica
            disabledDate={(current) => {
              const hoje = dayjs().startOf("day");

              // Se current for undefined, retorna false (não desativa nada)
              if (!current) return false;

              // Desativa datas antes de hoje ou antes da data de início
              return current.isBefore(hoje, 'day') || (inicio ? current.isBefore(inicio, 'day') : false);
            }}
          />


          <BotaoAdd
            onClick={adicionarPeriodo}
            disabled={!inicio || !fim}
            type="primary"
          >
            <PlusCircleOutlined /> Adicionar
          </BotaoAdd>
        </Row>
      </InputArea>

      {periodos.length > 0 && (
        <Lista>
          {periodos.map((p, i) => (
            <Item key={i}>
              {dayjs(p.inicio).format('DD/MM/YYYY')} até {dayjs(p.fim).format('DD/MM/YYYY')}
              <DeleteIcon onClick={() => remover(i)} />
            </Item>
          ))}
        </Lista>
      )}
    </Wrapper>
  );
};

export default SelecaoPeriodos;
